import styled from "styled-components";
import { FormControl, Grid } from "@material-ui/core";
import { Form } from "react-bootstrap";

export const Background = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 1000;
  top: 0;
  bottom: 0;
`;

export const ModalWrapper = styled.div`
  background: #ffffff;
  border: 0.0625rem solid #e5e5e5;
  box-shadow: 0rem 1.25rem 2.5rem -0.75rem rgba(196, 196, 196, 0.35);
  box-sizing: border-box;
  padding: 1.25rem 1.875rem;
  width: 45rem;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  z-index: 10;
`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  & p {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 0;
  }
`;

export const StyledForm = styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const CheckboxContainer = styled(Grid)`
  flex: 1;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 1rem;

  /* Barra de desplazamiento para navegadores basados en WebKit */
  &::-webkit-scrollbar {
    height: 12px !important; /* Cambia el grosor de la barra */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b0b0b0 !important; /* Color de la barra */
    border-radius: 6px !important; /* Redondeo de los bordes */
    border: 3px solid #f1f1f1 !important; /* Espacio alrededor del pulgar de desplazamiento */
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1 !important; /* Color de fondo de la pista */
  }

  /* Barra de desplazamiento para navegadores con Firefox */
  scrollbar-width: thin;
  scrollbar-color: #b0b0b0 #f1f1f1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding: 0.625rem 0;
  background-color: #fff;
  border-top: 1px solid #e5e5e5;
  position: sticky;
  bottom: 0;
`;

export const CustomCheckbox = styled.input`
  /* Hide the default checkbox */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  border: none;
  background-color: transparent;
  /* Set the custom checkbox size */
  width: 16px;
  height: 16px;
  /* Define the custom checkbox appearance */
  border: 2px solid #4f4184;
  border-radius: 3px;
  margin-right: 4px;
  cursor: pointer;
  /* Change the background color when the checkbox is checked */
  &:checked {
    background-color: #4f4184;
  }
`;

export const IconContainer = styled.div`
  cursor: pointer;
  & svg {
    font-size: 1.5rem;
    color: #4f4184;
  }
`;

export const FormGroup = styled(FormControl)`
  width: 100%;
  height: 4.375rem;
`;

export const ApproveMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & svg {
    color: #34a853;
    font-size: 3.125rem;
    margin-bottom: 0.5rem;
  }
  & span {
    text-align: center;
    margin-bottom: 20px;
  }
`;

export const Divider = styled.hr`
  padding: 0 1.875rem;
  margin: 0;
`;

export const Div = styled(Grid)`
  align-items: center;
  padding: 0.875rem 1.875rem;
  & p {
    margin: 0;
  }
`;
